module.exports = __webpack_public_path__ + "img/ic_food_cake.aac6e3d3.png";